import { QueryClient } from "@tanstack/react-query";

import { QUERY_REFETCH_INTERVAL_MS } from "../config/constants";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_REFETCH_INTERVAL_MS / 2,
        refetchInterval: QUERY_REFETCH_INTERVAL_MS,
        refetchOnWindowFocus: false,
        retry: 1,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
